import { toNumber } from 'helpers/environment';

const initialZoom = 15;
const maxZoomOutIncrements = 195;

export const zoomConfig = {
  zoomIncrementSize: 0.05,
  initialZoom,
  minZoomIncrements: initialZoom - toNumber(process.env.REACT_APP_ZOOM_IN_LIMIT, 32)!,
  maxZoomIncrements: initialZoom + maxZoomOutIncrements,
};
